export enum PineLabDefaultChannel {
   PAYMENT_CHANNEL = 'pine-labs-pos-channel',
 } 
 
export enum PineLabsEnum  {
    PAYMENT_GATEWAY = 'pinelabs',
    PAYMENT_ORIGIN = 'pos',
    PAYMENT_PROCESS = 'checkout',
    PAYMENT_SUCCESS = 'success',
    PAYMENT_FAILED = 'failed',
    PAYMENT_CANCELLED = 'cancelled',
    BACK_CLICKED = 'popstate',
    POP_UP_MINIMIZE = 'minimize',
  };

 export enum PineLabStorageEnum {
   PINE_LAB_STORAGE = 'pine_lab_data',
   PL_MERGE_ORDER_LATEST_SEL = 'latest_selected_order_left_id',
   PL_INTERVAL_ID = 'pl_interval_id'
 } 

  export enum PineLabsSettlementEnum {
   CREDIT_COL = 'pine_labs_credit_collected',
   DEBIT_COL = 'pine_labs_debit_collected',
   WALLET_COL = 'pine_labs_wallet_collected',
  }

  export enum PineLabsSettlementCls {
    CREDIT_CLS = 'pl-crd-cls',
    DEBIT_CLS = 'pl-dbt-cls',
    WALLET_CLS = 'pl-wlt-cls'
  }

  export enum PineLabsMergePopupEnum {
   PL_IS_MERGE_OPEN = 'pl_is_merge_open',
   PL_OPEN = 'pl_open',
   PL_CLOSE = 'pl_close',
   CLOSE = 'close'
  }

  export enum PineLabsTimeOut {
   CANCEL = 'CANCEL',
   RETRY = 'RETRY',
   EXPIRED = 'EXPIRED'
  }

  export enum PineCancelPopUpEnum  {
     CANCEL_CANCELLED = 0,
     CANCEL_SUCCESS = 1,
     CANCEL_REJECTED = 2,
  };

  export const PineLabsConsts = {
   REDEEM_AMOUNT:0,
   SUCCESS:0,
   HUNDERED:100,
   DEADLINE_ONE_MINUTE : 60000,
   TOTAL_TIME_ONE_MINUTE : 60,
   DEFAULT_MINUTES : 4,
   POLLING_MINUTES : 3,
   ONE_MINUTE : 60000
  }

  export const PineLabPmtChannels = ["pine-labs-credit-card","pine-labs-pos-channel","pine-labs-upi-ewallet","pine-labs-debit-card"];